

import {createWebHistory, createRouter} from "vue-router";
import About from "@/components/About.vue";
import Index from "@/components/Index.vue";
import serviceItems from "@/components/ServiceItems.vue";
import industry from "@/components/Industry.vue";
import content from "@/components/Content.vue";
import Login from "@/components/Login.vue";
import Register from "@/components/Register.vue";

const routes = [
    { path: '/', component: Index },
    { path: '/index', component: Index },
    { path: '/about', component: About },
    { path: '/service', component: serviceItems },
    { path: '/industry', component: industry },
    { path: '/content', component: content },
    { path: '/login', component: Login },
    { path: '/register', component: Register},
    //


]
const router = createRouter({
    history: createWebHistory(),
    routes,
})



export default router